import { Log } from './Log';
import * as SignageAbstractions from '@reachmedianetwork/signage-abstractions';

/**
 * Generic implementation to write named events to all configured logging
 * mechanisms. See docs for ILogMechanism.NamedEvent.
 */
export function NamedEvent<Event extends SignageAbstractions.NamedEventCode>(
    code: Event,
    message: string,
    source: string,
    data: SignageAbstractions.NamedEventData[Event]
): void {
    source = source || 'unknown';

    if (Log.Mechanism) {
        Log.Mechanism.forEach(function (currentMechanism) {
            if (currentMechanism.NamedEvent) {
                currentMechanism.NamedEvent(code, message, source, data);
            }
        });
    }
}
